import { render, staticRenderFns } from "./image-list.vue?vue&type=template&id=626c45cf&"
import script from "./image-list.vue?vue&type=script&lang=js&"
export * from "./image-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports